import React from "react";
import {MessageFeedbackInListUi} from "../../../../../api/generated";
import {formatDateTime} from "../../../../../utils/dateTimeUtil";
import {messageFeedbackTranscriptLink} from "../../feedbackTranscriptLink";
import {FeedbackRatingChip} from "./FeedbackRatingChip";
import {OpenTranscriptButton} from "./OpenTranscriptButton";
import {RatedAnswer} from "./RatedAnswer";
import styles from "./FeedbackTable.module.css";

interface MessageFeedbackTableProps {
    feedback: MessageFeedbackInListUi[]
}

export const MessageFeedbackTable: React.FC<MessageFeedbackTableProps> = ({feedback}) => {
    return <div role="table" aria-label="Message ratings" className={styles.table}>
        <div role="row" className={`${styles.messageRow} ${styles.headerRow}`}>
            <span role="columnheader">Date</span>
            <span role="columnheader">Assistant</span>
            <span role="columnheader">Rating</span>
            <span role="columnheader">Comment</span>
            <span role="columnheader">Rated answer</span>
            <span role="columnheader"/>
        </div>
        {feedback.length === 0 && <div className={styles.empty}>No feedback matches these filters.</div>}
        {feedback.map(item => {
            const {date, time} = formatDateTime(item.updatedAt);
            return <div role="row" key={item.id} className={styles.messageRow}>
                <div role="cell" className={styles.cell}>
                    <div>{date}</div>
                    <div className={styles.secondary}>{time}</div>
                </div>
                <div role="cell" className={styles.cell}>{item.botName ?? "Unknown Assistant"}</div>
                <div role="cell" className={styles.cell}><FeedbackRatingChip rating={item.rating}/></div>
                <div role="cell" className={styles.cell}>
                    {item.comment ? `“${item.comment}”` : <span className={styles.muted}>No comment</span>}
                </div>
                <div role="cell" className={styles.cell}>
                    {item.ratedMessage && <RatedAnswer text={item.ratedMessage}/>}
                </div>
                <div role="cell">
                    <OpenTranscriptButton to={messageFeedbackTranscriptLink(item, item.chatHistoryId)}/>
                </div>
            </div>
        })}
    </div>
}
